import React from "react";

//Boxed notice on cream (Decor Hire "Launch Special!", Contact "Site Visits")
const SpecialNotice = ({ title, paragraphs }) => (
  <section className={"boxed-section tone-grey"}>
    <div className={"container"}>
      <div className={"gold-box special-notice"}>
        <h2 className={"special-notice-title"}>{title}</h2>
        {paragraphs.map((p) => <p key={p}>{p}</p>)}
      </div>
    </div>
  </section>
);

export default SpecialNotice;
